module.exports = __webpack_public_path__ + "img/tur.0256dd98.png";